exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#risk-popout {\n  background: black;\n  display: flex;\n  height: 100%;\n  color: white;\n  padding: 0.5rem;\n  box-sizing: border-box;\n  flex-direction: column; }\n  #risk-popout > :only-child {\n    flex: 1 1 auto; }\n", ""]);

// exports
